export const isLastPageTool = (pageCount, currentPage, totalCount, limit) =>
  pageCount * currentPage === totalCount || pageCount < limit;

export const isPageIndexOff = (results, filter) =>
  (!results || results?.length === 0) && filter?.page && filter?.page !== 1 ? true : false;

export const isEmptyList = (results, filter) =>
  (!results || results?.length === 0) && filter?.page === 1 ? true : false;
